import type { TemplateProps } from "./types"
import { BaseTemplate } from "./BaseTemplate"

/** Classic Nonprofit: traditional, trustworthy. Navy + gold. Serif headings. Warmer, formal. */
export function ClassicNonprofitTemplate(props: TemplateProps) {
  const primary = props.customizations.primary_color ?? "#1e3a8a"
  const secondary = props.customizations.secondary_color ?? "#f59e0b"

  return (
    <div
      className="antialiased"
      style={
        {
          "--primary-color": primary,
          "--secondary-color": secondary,
          fontFamily: props.customizations.font_family ?? "Inter, sans-serif",
        } as React.CSSProperties
      }
    >
      <BaseTemplate {...props} />
    </div>
  )
}
